import { useNavigate } from "react-router-dom";
import "./LetsHealp.scss";
import { useState } from "react";

const LetsHealp = ({ data, theme }) => {
  const navigate = useNavigate();
  const [move, setMove] = useState(false);

  const enter = () => {
    setMove(true);
  };
  const leave = () => {
    setMove(false);
  };

  const helpHandler = () => {
    navigate(data?.link);
  };

  return (
    <section className={`lets_help ${theme ? "dark" : "light"}`}>
      <div className="content_wrap p_bottom">
        <div className="left">
          <h2 className="wow fadeInUp">
            {data?.section_1_description ||
              "Identifying the most advanced, feature-rich solutions with an emphasis on security and value."}
          </h2>
          <button
            type="button"
            className="help_btn wow fadeInUp"
            data-wow-delay="0.15s"
            onMouseEnter={enter}
            onMouseLeave={leave}
            onClick={helpHandler}
          >
            <h2>Know More</h2>
          </button>
        </div>

        <button
          type="button"
          className="big_arrow_btn wow fadeInUp"
          style={{ transform: `Rotate(${move ? "45deg" : "0deg"})` }}
          onMouseEnter={enter}
          onMouseLeave={leave}
          onClick={helpHandler}
        ></button>
      </div>
    </section>
  );
};

export default LetsHealp;
